import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../_helper/SharedData";
import {
    showAlert,
} from "../../Services/Shared.service";
import { Breadcrumbs, Btn, CommonModal, H6 } from "../../AbstractElements";
import { Row, Col, Card, CardBody, Container, Modal, ModalBody, Nav, NavItem, NavLink } from "reactstrap";
import { Plus } from "react-feather";
import { getZoneList } from "../../Services/Zone.service";
import ZoneTable from "./ZoneTable";
import ZoneInput from "./ZoneInput";
const Zone = () => {
    const { cityData, globalCityField, setShowApiLoader } =
        useContext(SharedDataContext);
    const [tableData, setTableData] = useState([]);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [editId, setEditId] = useState("")

    const onChangePage = (page) => {
        console.log("page", page);
        setPagination(page - 1);
    };

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    useEffect(() => {
        fetchTableData();
    }, [globalCityField.value, pagination, rowsPerPage]);

    const fetchTableData = () => {
        const serviceCityId = globalCityField.value?.id || '0';
        let obj = {
            serviceCityId: serviceCityId,
            page: pagination,
            size: rowsPerPage,
        };
        setLoader(true);
        getZoneList(obj)
            .then((result) => {
                setPaginationTotalRows(result.data.count);
                setTableData(result.data.list);
                disableLoaders();
            })
            .catch((err) => {
                disableLoaders();
                showAlert("error", err.response?.data?.message
                    ? err.response.data.message : "Something went wrong");
            });
    };
    const disableLoaders = () => {
        setLoader(false);
        // setShowApiLoader(false);
    };


    return (
        <Fragment>
            <Breadcrumbs
                parent="Configuration"
                subParent="Zone"
                mainTitle="Zone"
                span1={
                    <Btn attrBtn={{ style: { display: "flex", padding: "7px 14px", justifyContent: "center", alignItems: "center" }, onClick: (e) => setIsOpen(true) }}>
                        <Plus size={"18px"} style={{ marginRight: "5px" }} /> Add
                    </Btn>
                }
            />
            <Container fluid={true} className="datatables">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                <ZoneTable
                                    fetchTableData={fetchTableData}
                                    tableData={tableData}
                                    setShowApiLoader={setLoader}
                                    onChangePage={onChangePage}
                                    paginationPerPage={rowsPerPage}
                                    paginationTotalRows={paginationTotalRows}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    onEditClick={(element) => {
                                        setIsOpen(true)
                                        setEditId(element?.id)
                                    }}
                                    loader={loader}
                                    editId={editId}
                                    setEditId={setEditId}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ZoneInput cityData={cityData} editId={editId} setEditId={setEditId} setIsOpen={setIsOpen} fetchTableData={fetchTableData} isOpen={isOpen} />
        </Fragment>
    );
};

export default Zone;
